import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import AnalyticChartData from "../../../../api/AnalyticChartData";
import stateAnalyticApp from "../../../../state/stateAnalyticApp";
import { useShiftKey } from "./hooks/useShiftKey";
import { PrintDatesChart } from "./charts/PrintDatesChart";
import { PrintCountChart } from "./charts/PrintCountChart";
import { VerifyDatesChart } from "./charts/VerifyDatesChart";
import { VerifyCountChart } from "./charts/VerifyCountChart";

const GraphsContent = observer(
  ({ refApp, shiftPress, setScaleGraph, setScaleGraphFlag }) => {
    const allLoaded =
      stateAnalyticApp.loaded_printed_dates &&
      stateAnalyticApp.loaded_printed_count &&
      stateAnalyticApp.loaded_verify_dates &&
      stateAnalyticApp.loaded_verify_count;

    const isEmpty =
      allLoaded &&
      AnalyticChartData.DataSet.PRINT.dates.series.length === 0 &&
      AnalyticChartData.DataSet.PRINT.labelCount.series.length === 0 &&
      AnalyticChartData.DataSet.SERIALISATION.dates.series.length === 0 &&
      AnalyticChartData.DataSet.SERIALISATION.datasetsCount.data_print.length === 0;

    if (isEmpty) {
      return <p className="grey_info">Графики за выбранный период не найдены</p>;
    }

    return (
      <div className="graphs_container">
        <PrintDatesChart
          refApp={refApp}
          shiftPress={shiftPress}
          setScaleGraph={setScaleGraph}
          setScaleGraphFlag={setScaleGraphFlag}
        />
        <PrintCountChart
          refApp={refApp}
          shiftPress={shiftPress}
          setScaleGraph={setScaleGraph}
          setScaleGraphFlag={setScaleGraphFlag}
        />
        <VerifyDatesChart
          refApp={refApp}
          shiftPress={shiftPress}
          setScaleGraph={setScaleGraph}
          setScaleGraphFlag={setScaleGraphFlag}
        />
        <VerifyCountChart
          refApp={refApp}
          shiftPress={shiftPress}
          setScaleGraph={setScaleGraph}
          setScaleGraphFlag={setScaleGraphFlag}
        />
      </div>
    );
  },
);

export const GraphConteiner = observer(({ refApp }) => {
  const shiftPress = useShiftKey();
  const [, setScaleGraph] = useState(null);
  const [, setScaleGraphFlag] = useState(null);

  return (
    <GraphsContent
      refApp={refApp}
      shiftPress={shiftPress}
      setScaleGraph={setScaleGraph}
      setScaleGraphFlag={setScaleGraphFlag}
    />
  );
});
